import styled from "styled-components";
import React from "react";
import { EvidenceIcon } from "./EvidenceIcon";

export function SelectedEvidence({ evidence, className, onRemoveEvidence }) {
  return (
    <SelectionLayout className={className}>
      <RemoveButton
        onClick={() => {
          onRemoveEvidence(evidence);
        }}
      >
        X
      </RemoveButton>
      <EvidenceText>{evidence}</EvidenceText>
      <Icon evidence={evidence} />
    </SelectionLayout>
  );
}
const Icon = styled(EvidenceIcon)``;
const EvidenceText = styled.div`
  margin-top: auto;
  margin-bottom: auto;
  @media (max-width: 1000px) {
    visibility: hidden;
    width: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const SelectionLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
export const RemoveButton = styled.button`
  margin-left: auto;
  background: #5181ac;
  margin-top: 5px;
  margin-right: 5px;
  margin-left: 15px;
  margin-bottom: 5px;
  border-thickness: 0px;
  :hover& {
    background: #7ab6db;
  }
  color: white;
  padding: 10px;
  border: none;
  text-align: center;
  text-decoration: none;
  display: inline-block;
`;
